/* tslint:disable */
/* eslint-disable */
/**
 * Business Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
/* eslint-disable */

/**
* このファイルは自動生成されています。そのためgit管理には含まれません。手動で編集してもdeploy時反映されません。
*/

/**
 * 配車状態
 * @export
 * @enum {number}
 */
export enum CarDispatchStatusEnum {
    /** 配車中（未応答） */
    UNCONFIRMED = '1',
    /** 探車失敗 */
    SEARCH_FAILED = '2',
    /** 迎車中（現着前） */
    DISPATCHING = '3',
    /** 迎車中（現着済） */
    ARRIVED = '4',
    /** 実車中 */
    BOARDING = '5',
    /** 代車要請中 */
    REPLACEMENT = '6',
    /** 支払完了 */
    PAYMENT_DONE = '7',
    /** 支払中（決済失敗） */
    PAYMENT_FAILED = '8',
    /** 実車中 */
    IN_PROGRESS = '9',
    /** 利用者キャンセル */
    USER_CANCELLED = '11',
    /** 事業者キャンセル */
    OPERATOR_CANCELLED = '12',
    /** QR連携キャンセル */
    QR_CANCELLED = '13'
}

/**
 * 配車状態 の Union 型
 * @export
 * @typedef CarDispatchStatus
 */
export type CarDispatchStatus =
  typeof CarDispatchStatusEnum[keyof typeof CarDispatchStatusEnum];

/**
 * 配車状態 のラベルマップ
 * @export
 */
export const CarDispatchStatusLabels = {
    /**
     * 数値キー: CarDispatchStatusEnum.UNCONFIRMED
     * 名前キー:  UNCONFIRMED
     */
    [CarDispatchStatusEnum.UNCONFIRMED]: '配車中（未応答）',
    UNCONFIRMED:                             '配車中（未応答）',
    /**
     * 数値キー: CarDispatchStatusEnum.SEARCH_FAILED
     * 名前キー:  SEARCH_FAILED
     */
    [CarDispatchStatusEnum.SEARCH_FAILED]: '探車失敗',
    SEARCH_FAILED:                             '探車失敗',
    /**
     * 数値キー: CarDispatchStatusEnum.DISPATCHING
     * 名前キー:  DISPATCHING
     */
    [CarDispatchStatusEnum.DISPATCHING]: '迎車中（現着前）',
    DISPATCHING:                             '迎車中（現着前）',
    /**
     * 数値キー: CarDispatchStatusEnum.ARRIVED
     * 名前キー:  ARRIVED
     */
    [CarDispatchStatusEnum.ARRIVED]: '迎車中（現着済）',
    ARRIVED:                             '迎車中（現着済）',
    /**
     * 数値キー: CarDispatchStatusEnum.BOARDING
     * 名前キー:  BOARDING
     */
    [CarDispatchStatusEnum.BOARDING]: '実車中',
    BOARDING:                             '実車中',
    /**
     * 数値キー: CarDispatchStatusEnum.REPLACEMENT
     * 名前キー:  REPLACEMENT
     */
    [CarDispatchStatusEnum.REPLACEMENT]: '代車要請中',
    REPLACEMENT:                             '代車要請中',
    /**
     * 数値キー: CarDispatchStatusEnum.PAYMENT_DONE
     * 名前キー:  PAYMENT_DONE
     */
    [CarDispatchStatusEnum.PAYMENT_DONE]: '支払完了',
    PAYMENT_DONE:                             '支払完了',
    /**
     * 数値キー: CarDispatchStatusEnum.PAYMENT_FAILED
     * 名前キー:  PAYMENT_FAILED
     */
    [CarDispatchStatusEnum.PAYMENT_FAILED]: '支払中（決済失敗）',
    PAYMENT_FAILED:                             '支払中（決済失敗）',
    /**
     * 数値キー: CarDispatchStatusEnum.IN_PROGRESS
     * 名前キー:  IN_PROGRESS
     */
    [CarDispatchStatusEnum.IN_PROGRESS]: '実車中',
    IN_PROGRESS:                             '実車中',
    /**
     * 数値キー: CarDispatchStatusEnum.USER_CANCELLED
     * 名前キー:  USER_CANCELLED
     */
    [CarDispatchStatusEnum.USER_CANCELLED]: '利用者キャンセル',
    USER_CANCELLED:                             '利用者キャンセル',
    /**
     * 数値キー: CarDispatchStatusEnum.OPERATOR_CANCELLED
     * 名前キー:  OPERATOR_CANCELLED
     */
    [CarDispatchStatusEnum.OPERATOR_CANCELLED]: '事業者キャンセル',
    OPERATOR_CANCELLED:                             '事業者キャンセル',
    /**
     * 数値キー: CarDispatchStatusEnum.QR_CANCELLED
     * 名前キー:  QR_CANCELLED
     */
    [CarDispatchStatusEnum.QR_CANCELLED]: 'QR連携キャンセル',
    QR_CANCELLED:                             'QR連携キャンセル',
} as const;

/**
 * 配車状態 のラベル Union 型
 * @export
 * @typedef CarDispatchStatusLabel
 */
export type CarDispatchStatusLabel =
  typeof CarDispatchStatusLabels[keyof typeof CarDispatchStatusLabels];

/**
 * 配車状態 のラベル取得関数
 * @export
 * @param { CarDispatchStatus } value - 列挙体の値
 * @returns { CarDispatchStatusLabel } ラベル文字列
 */
export function getCarDispatchStatusLabel(
  value: CarDispatchStatus
): CarDispatchStatusLabel {
  return CarDispatchStatusLabels[value];
}

/**
 * 配車状態 のラベル配列を取得する関数
 * @export
 * @param { CarDispatchStatus[] } values - 列挙体の値配列
 * @returns { CarDispatchStatusLabel[] } ラベル文字列配列
 */
export function getCarDispatchStatusLabels(values: CarDispatchStatus[]): CarDispatchStatusLabel[] {
  return values.map((value) => getCarDispatchStatusLabel(value));
}

/**
 * 配車状態 のラベル配列
 * @export
 */
export const CarDispatchStatusLabelList = [
  '配車中（未応答）','探車失敗','迎車中（現着前）','迎車中（現着済）','実車中','代車要請中','支払完了','支払中（決済失敗）','実車中','利用者キャンセル','事業者キャンセル','QR連携キャンセル',
] as const;

